/* RESPONSIBLE TEAM: team-proactive-support */

export enum MaxLimit {
  OUTBOUND = 25,
}
